import React, { PropsWithChildren, useContext, useState } from "react";
import {
  MenuContainer,
  MenuItemLink,
  MenuList,
  MenuListItem,
} from "./Menu.elements";
import { useRouter } from "next/router";
import Link from "next/link";
import { Data, MenuModel } from "../../../types/models";

interface Props {
  menu?: Data<MenuModel>;
}

const Menu = ({ menu }: PropsWithChildren<Props>) => {
  const router = useRouter();
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(!open);

  return (
    <MenuContainer isOpen={open} onClick={handleOpen}>
      <MenuList isOpen={open}>
        {menu?.data?.attributes?.links?.map((link, key) => {
          const url = link.url ? link.url : link?.page?.data?.attributes.url;
          return (
            <MenuListItem key={key}>
              <Link href={url || router.route} passHref>
                <MenuItemLink isActive={url === router.asPath}>
                  {link.label}
                </MenuItemLink>
              </Link>
            </MenuListItem>
          );
        })}
      </MenuList>
    </MenuContainer>
  );
};

export default Menu;
